// extracted by mini-css-extract-plugin
export default {"circle":"BatchDetails_circle__Juq-c","root":"BatchDetails_root__70WOD"};